<div class="box" [attr.data-theme]="theme" [attr.data-hollow]="hollow">
  <div class="box__header">
    <ng-content select="[header]"></ng-content>
  </div>
  <div class="box__content">
    <ng-content select="[content]"></ng-content>
  </div>
</div>
